import { createContext, useContext } from "react";

// Split from VanoCodesProvider.jsx deliberately: a file that exports both a component and
// non-component values (like this hook) breaks React Fast Refresh (react-refresh/only-export-
// components) - this file holds only the context object + hook, no JSX, no component export.
export const VanoCodesContext = createContext(null);

export function useVanoCodes() {
  const catalog = useContext(VanoCodesContext);
  if (catalog === null) {
    throw new Error("useVanoCodes() called outside VanoCodesProvider (or before ready)");
  }
  return catalog;
}
